import React from "react";
import Lottie from "lottie-react";
import noInternetAnim from "../../assets/loader/nointernet.json";
import "./NoInternet.css";

import { RefreshCw } from "lucide-react";

const NoInternet = () => {
  const handleRetry = () => {
    window.location.reload();
  };

  return (
    <div className="no-internet-overlay">
      <div className="no-internet-content">
        {/* Premium Illustration via Lottie */}
        <div className="no-internet-lottie-container">
          <Lottie
            animationData={noInternetAnim}
            loop={true}
            className="no-internet-lottie"
          />
        </div>

        <h1 className="no-internet-title">Connection Lost</h1>
        <p className="no-internet-text">
          It looks like you're offline. Please check your network connection and
          try again.
        </p>
      </div>
    </div>
  );
};

export default NoInternet;
